import { jsx } from "react/jsx-runtime";
import "react";
import { Text } from "@zillow/constellation";
import PropTypes from "prop-types";
const TextInline = ({
  fontColor,
  fontSize,
  fontWeight,
  fontFamily,
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(Text, { fontColor: fontColor || "inherit", style: {
    fontSize: fontSize || "inherit",
    fontWeight: fontWeight || "inherit",
    fontFamily: fontFamily || "inherit"
  }, ...rest, children });
};
TextInline.propTypes = {
  fontColor: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  fontFamily: PropTypes.string
};
export {
  TextInline as default
};
